export function padNumber (num, size) {
  let s = num + ''
  while (s.length < size) s = '0' + s
  return s
}

export function padDecimal (num, size, decimal = 2) {
  return padNumber(roundDecimal(num, decimal), size)
}

export function padDecimalWithoutDot (num, size, decimal = 2) {
  return padNumber(Math.round(num * Math.pow(10, decimal)), size)
}

export function roundDecimal (num, decimal = 2) {
  const mul = Math.pow(10, decimal)
  num = Math.round(num * mul) / mul
  return num.toFixed(decimal)
}

export function padText (s, size) {
  if (s == null) {
    s = ''
  } else {
    s = s + ''
  }
  if (s.length > size) {
    return s.substring(0, size)
  }
  while (s.length < size) s += ' '
  return s
}

export function space(size) {
  return padText('', size)
}

export function convertWhtCode (whtCode) {
  // start with 3 => 05
  // 53 => 07
  whtCode = whtCode.toString()
  if (whtCode.startsWith('53'))
    return '07'
  else if(whtCode.startsWith('3'))
    return '05'

  console.error('unsupported whtCode: ' + whtCode)
  return '05'
}

export default {
  padNumber,
  padDecimal,
  padDecimalWithoutDot,
  roundDecimal,
  padText,
  space,
  convertWhtCode
}